<section class="section home-magazine">
  <div class="content">
    <h2>{{ translationService.getTranslatedAttribute('title', magazine.translations, locale)}}</h2>
    <p>{{ translationService.getTranslatedAttribute('subtitle', magazine.translations, locale) }}</p>
    <a (click)="downloadMagazine($event, magazine.id)" class="button button-large button-violet-outline">
      {{'academy.Reply'|translate}}
    </a>
  </div>
</section>